<template>
    <div>
        <div class="container">
            <!-- 操作 -->
            <div class="seach-container" style="padding: 0px 0px;">
              <div class="flex flex-wrap justify-between">
                <div class="form-container">
                  <el-button style="margin-left: 6px;" type="primary" size="mini" icon="el-icon-plus" @click="onChangeAdd">新增</el-button>
                </div>
              </div>
            </div>
            <!--表格树内容栏-->
            <el-table
              :data="tableData"
              :max-height="scrollHeight"
              rowKey="MenuID" element-loading-text="loading"
              border
              default-expand-all
              :tree-props="{ children: 'Children', hasChildren: 'hasChildren' }">
              <el-table-column
                prop="MenuID" header-align="center" align="center" width="180" label="ID">
              </el-table-column>
              <el-table-column 
                prop="MenuName" align="center" label="名称">
                <template #default="scope">
                    <span v-if="scope.row.Level === 0 && scope.row.Type === 0">
                        <el-tag size="small">{{scope.row.MenuName}}(一级目录)</el-tag>
                    </span>
                    <span v-else-if="scope.row.Level === 0 && scope.row.Type === 1">
                        <el-tag size="small" type="success">{{scope.row.MenuName}}(一级菜单)</el-tag>
                    </span>
                    <span v-if="scope.row.Level === 1 && scope.row.Type === 0">
                        <el-tag size="small">{{scope.row.MenuName}}(二级目录)</el-tag>
                    </span>
                    <span v-else-if="scope.row.Level === 1 && scope.row.Type === 1">
                        <el-tag size="small" type="success">{{scope.row.MenuName}}(二级菜单)</el-tag>
                    </span>
                    <span v-if="scope.row.Level === 2 && scope.row.Type === 0">
                        <el-tag size="small">{{scope.row.MenuName}}(三级目录)</el-tag>
                    </span>
                    <span v-else-if="scope.row.Level === 2 && scope.row.Type === 1">
                        <el-tag size="small" type="success">{{scope.row.MenuName}}(三级菜单)</el-tag>
                    </span>
                    <span v-else-if="scope.row.Type === 2">
                        <el-tag size="small" type="info">{{scope.row.MenuName}}(按钮)</el-tag>
                    </span>
                </template>
              </el-table-column>
              <el-table-column header-align="center" width="60" align="center" label="图标">
                <template #default="scope">
                  <i :class="scope.row.Icon || ''"></i>
                </template>
              </el-table-column>
              <el-table-column prop="Type" header-align="center" width="150" align="center" label="类型">
                <template #default="scope">
                  <el-tag v-if="scope.row.Type === 0" size="small">目录</el-tag>
                  <el-tag v-else-if="scope.row.Type === 1" size="small" type="success">菜单</el-tag>
                  <el-tag v-else-if="scope.row.Type === 2" size="small" type="info">按钮</el-tag>
                </template>
              </el-table-column>
              <el-table-column 
                prop="ParentMenuName" header-align="center" align="center" label="上级菜单">
                <template #default="scope">
                    <span v-if="scope.row.ParentMenuID === 0">
                        无上级菜单
                    </span>
                    <span v-else>
                        {{scope.row.ParentMenuName}}
                    </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="ViewPath" header-align="center" align="center" width="250" 
                :show-overflow-tooltip="true" label="菜单URL">
              </el-table-column>
              <el-table-column
                prop="Perms" header-align="center" align="center" 
                :show-overflow-tooltip="true" label="授权标识">
              </el-table-column>
              <el-table-column
                prop="OrderNum" header-align="center" align="center" width="100" label="排序">
              </el-table-column>
              <el-table-column
                fixed="right" header-align="center" align="center" width="250" label="操作">
                <template #default="scope">
                  <el-button icon="el-icon-edit" size="mini" type="primary" @click="onChangeEdit(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" type="danger" @click="onChangeDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </div>

        <!-- 添加目录、菜单、按钮界面 -->
        <el-dialog :title="'添加目录、菜单、按钮'" v-model="dialogVisibleAdd" width="40%">
          <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
            label-width="80px" :size="size" style="text-align:left;">
            <el-form-item label="菜单类型" prop="Type">
              <el-radio-group v-model="dataForm.Type" @change="onChangeType">
                <el-radio v-for="(type, index) in menuTypeList" :label="index" :key="index">{{ type }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="menuTypeList[dataForm.Type] + '名称'" prop="MenuName">
              <el-input v-model="dataForm.MenuName" :placeholder="menuTypeList[dataForm.Type] + '名称'"></el-input>
            </el-form-item>
            <el-form-item label="上级菜单" prop="ParentMenuName">
              <el-input v-model="dataForm.ParentMenuName" :readonly="true" placeholder="请在下面目录树中选择上级菜单" style="cursor:pointer;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-scrollbar
                  wrapClass="scrollbar-wrap"
                  max-height="180px"
                  ref="scrollbarContainer">
                  <el-tree
                      :data="popupTreeData"
                      :props="popupTreeProps"
                      node-key="MenuID"
                      ref="popupTree"
                      @current-change="onTreeSelectChange"
                      :default-expand-all="true"
                      :highlight-current="true"
                      :expand-on-click-node="true">
                  </el-tree>
                </el-scrollbar>
            </el-form-item>
            <el-form-item v-if="dataForm.Type === 2" label="授权标识" prop="Perms">
              <el-input v-model="dataForm.Perms" placeholder="如: bank-addBtn,必须唯一"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.Type !== 2" label="菜单路由" prop="ViewPath">
              <el-input v-model="dataForm.ViewPath" placeholder="菜单路由"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.type !== 2" label="排序编号" prop="OrderNum">
              <el-input-number v-model="dataForm.OrderNum" controls-position="right" :min="0" label="排序编号"></el-input-number>
            </el-form-item>
            <el-form-item v-if="dataForm.Type !== 2" label="菜单图标" prop="Icon">
              <el-input v-model="dataForm.Icon" v-popover:iconListPopover :readonly="false" placeholder="菜单图标名称（如：fa fa-home fa-lg）" class="icon-list__input"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-footer" >
            <el-button  @click="dialogVisibleAdd = false">取消</el-button>
            <el-button  type="primary" @click="addMenuFunction()">保存</el-button>
          </div>
        </el-dialog>

        <!-- 编辑目录、菜单、按钮界面 -->
        <el-dialog :title="'修改目录、菜单、按钮'" v-model="dialogVisibleEdit" width="40%">
          <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
            label-width="80px" :size="size" style="text-align:left;">
            <el-form-item label="菜单类型" prop="Type">
              <el-radio-group disabled v-model="dataForm.Type" @change="onChangeType()">
                <el-radio v-for="(type, index) in menuTypeList" :label="index" :key="index">{{ type }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="menuTypeList[dataForm.Type] + '名称'" prop="MenuName">
              <el-input v-model="dataForm.MenuName" :placeholder="menuTypeList[dataForm.Type] + '名称'"></el-input>
            </el-form-item>
            <el-form-item label="上级菜单" prop="ParentMenuName">
              <el-input v-model="dataForm.ParentMenuName" :readonly="true" placeholder="请在下面目录树中选择上级菜单" style="cursor:pointer;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-scrollbar
                  wrapClass="scrollbar-wrap"
                  max-height="180px"
                  ref="scrollbarContainer">
                  <el-tree
                      :data="popupTreeData"
                      :props="popupTreeProps"
                      node-key="MenuID"
                      ref="popupTree"
                      @current-change="onTreeSelectChange"
                      :default-expand-all="true"
                      :highlight-current="true"
                      :expand-on-click-node="true">
                  </el-tree>
                </el-scrollbar>
            </el-form-item>
            <el-form-item v-if="dataForm.Type === 2" label="授权标识" prop="Perms">
              <el-input v-model="dataForm.Perms" placeholder="如: bank-addBtn,必须唯一"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.Type !== 2" label="菜单路由" prop="ViewPath">
              <el-input v-model="dataForm.ViewPath" placeholder="菜单路由"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.type !== 2" label="排序编号" prop="OrderNum">
              <el-input-number v-model="dataForm.OrderNum" controls-position="right" :min="0" label="排序编号"></el-input-number>
            </el-form-item>
            <el-form-item v-if="dataForm.Type !== 2" label="菜单图标" prop="Icon">
              <el-input v-model="dataForm.Icon" v-popover:iconListPopover :readonly="false" placeholder="菜单图标名称（如：fa fa-home fa-lg）" class="icon-list__input"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-footer" >
            <el-button  @click="dialogVisibleEdit = false">取消</el-button>
            <el-button  type="primary" @click="editMenuFunction()">保存</el-button>
          </div>
        </el-dialog>
        
    </div>
</template>

<script>
  import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
</style>
